class FinderController {

    constructor() {

        // Estados
        this.CLEARED = "CLEARED";
        this.WRITNG = "WRITING";
        this.SEARCHED = "SEARCHED";

        // Selectores
        this.content = null;
        this.quizWrapper = null;
        this.finderWrapper = null;
        this.finderInput = null;
        this.finderResults = null;
        this.finderBody = null;
        this.finderFilter = null;
        this.finderFilters = null;
        this.clearSearchButton = null;
        this.filtersButton = null;
        this.filtersButtonCell = null;

        // Plantillas
        this.finderTemplate = null;
        this.recentSearchesTemplate = null;
        this.recommendedSearchesTemplate = null;
        this.searchedResultsTemplate = null;
        this.filtersTemplate = null;

        // Datos y opciones
        this.documents = [];
        this.state = null;
        this.documentMatch = null;
        this.documentOpen = false;
        this.recommendedSearchesTimeOut = null
        this.timeToSendRecomendedSearchesRequest = 400;

        this.loadTemplates();
        this.loadEvents();

    }

    loadTemplates() {

        this.finderTemplate = Handlebars.compile($("#finder").html());
        this.recentSearchesTemplate = Handlebars.compile($("#recentSearches").html());
        this.recommendedSearchesTemplate = Handlebars.compile($("#recommendedSearches").html());
        this.searchedResultsTemplate = Handlebars.compile($("#searchedResults").html());
        this.filtersTemplate = Handlebars.compile($("#filters").html());

    }

    /**
     * The modal exists in the DOM (always).
     * We load this event starting the application.
     */
    loadEvents() {
        $(document).on("click.openFinder", "#open-finder-button", this.openFinder.bind(this));
        $(document).on("click.closeFinder", "#close-finder-button", this.closeFinder.bind(this));
        $(document).on("click.clearSearch", "#clear-search-button", this.clearSearch.bind(this));
        $(document).on("click.toggleFilters", "#filters-finder-button", this.toggleFiltersPanel.bind(this));
        $(document).on("click.filter", ".finder-filter-icon", this.toggleFilter);
        $(document).on("click.recentSearch", ".recent-search-label, .recommended-search-item", this.onSelectRecentSearch);
        $(document).on("input.change", "#finder-input", this.onInputChange.bind(this));
        $(document).on("submit.search", "#finder-form", this.onFormSubmit.bind(this));
    }

    /**
     * Use this method from React. (The events load when we demand it)
     */
    loadAsyncEvents() {
        $('.search-drawer').on("click.openFinder", "#open-finder-button", this.openFinder.bind(this));
        $('.search-drawer').on("click.closeFinder", "#close-finder-button", this.closeFinder.bind(this));
        $('.search-drawer').on("click.clearSearch", "#clear-search-button", this.clearSearch.bind(this));
        $('.search-drawer').on("click.toggleFilters", "#filters-finder-button", this.toggleFiltersPanel.bind(this));
        $('.search-drawer').on("click.filter", ".finder-filter-icon", this.toggleFilter);
        $('.search-drawer').on("click.recentSearch", ".recent-search-label, .recommended-search-item", this.onSelectRecentSearch);
        $('.search-drawer').on("input.change", "#finder-input", this.onInputChange.bind(this));
        $('.search-drawer').on("submit.search", "#finder-form", this.onFormSubmit.bind(this));
    }

    openFinder() {

        this.state = this.CLEARED;
        this.finderWrapper = $("#finder-wrapper");

        this.finderWrapper.html(this.finderTemplate);
        this.finderWrapper.addClass("opened");

        this.finderInput = $("#finder-input");
        this.finderResults = $("#finder-results");
        this.finderBody = $("#finder-body");
        this.finderFilters = $("#finder-filters");
        this.clearSearchButton = $("#clear-search-button");
        this.filtersButton = $("#filters-finder-button");
        this.filtersButtonCell = $(".filters-button-cell");
        this.content = $("section.content");
        this.quizWrapper = $(".quiz-wrapper");

        this.finderInput.focus();
        this.showRecentSearches();

    }

    closeFinder() {

        this.state = this.CLEARED;
        this.finderWrapper.html(null);
        this.finderWrapper.removeClass("opened");
        this.content.show();
        this.quizWrapper.show();

    }

    clearSearch() {
        this.state = this.CLEARED;
        this.finderInput.val("");
        this.finderResults.hide();
        this.clearSearchButton.hide();
        this.filtersButtonCell.hide();
        this.content.show();
        this.quizWrapper.show();

        this.showRecentSearches();
        this.hideFilters();

        this.finderResults.html(null);
        this.finderFilters.html(null);

        // console.log('clearSearch...', {
        //     state: this.state,
        //     finderInput: this.finderInput,
        //     finderResults: this.finderResults,
        //     clearSearchButton: this.clearSearchButton,
        // });
    }

    onInputChange() {

        const that = this;

        clearTimeout(this.recommendedSearchesTimeOut);

        if (this.finderInput.val().trim().length > 0) {
            this.state = this.WRITNG;
            this.recommendedSearchesTimeOut = setTimeout(that.showRecommendedSearches.bind(this), this.timeToSendRecomendedSearchesRequest);
        } else {
            this.state = this.CLEARED;
            this.showRecentSearches();
        }

        this.finderResults.hide();
        this.clearSearchButton.hide();
        this.filtersButtonCell.hide();
        this.content.show();
        this.quizWrapper.show();

        this.hideFilters();

        this.finderResults.html(null);
        this.finderFilters.html(null);

    }

    onFormSubmit(event) {
        
        event.preventDefault();

        const that = this;
        const requestObject = new Object();

        if (this.finderInput.val().trim().length > 0) {

            this.state = this.SEARCHED;
            this.finderBody.html(null);
            this.finderResults.show();
            this.clearSearchButton.show();
            this.content.hide();
            this.quizWrapper.hide();

            requestObject.world_token = world.token;
            requestObject.is_platform_search = false;
            requestObject.searched_text = this.finderInput.val().trim();

            api.getFinderDocuments(requestObject, function(response) {
                if (api.checkisValidResult(response, false, false)) {

                    if (that.state === that.SEARCHED) {
                        if (response.result && response.result.length > 0 && DocumentationUtils.getAvailableFiltersAmount(world) > 0) {
                            that.filtersButtonCell.show();
                            that.finderFilters.html(that.filtersTemplate ({
                                world: world,
                                playFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_PLAY"],
                                testFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_TEST"],
                                notSeenFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NOT_SEEN"],
                                favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
                                newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"],
                                shareFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_SHARE_LINK"],
                                rateFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_RATE"],
                            }));
                            that.finderFilter = $(".finder-filter-icon");
                        }
                        that.documents = response.result;
                        that.drawDocumentsList(that.documents);
                    }
                }
            });

        } else {
            this.state = this.CLEARED;
            this.filtersButtonCell.hide();
            this.finderFilters.html(null);
        }

    }

    onSelectRecentSearch(event) {

        const inputValue = $(this).data("value");

        finderController.finderInput.val(inputValue);
        finderController.onFormSubmit(event);

    }

    showRecentSearches() {
        const that = this;
        const requestObject = new Object();

        requestObject.world_token = world.token;
        requestObject.is_platform_search = false;

        api.getRecentSearches(requestObject, function(response){
            if (api.checkisValidResult(response, false, false)) {
                if (that.state === that.CLEARED) {
                    that.finderBody.html(that.recentSearchesTemplate(response.result));
                }
            }
        });

        this.finderBody.html(this.recentSearchesTemplate);
    }

    showRecommendedSearches() {

        const that = this;
        const requestObject = new Object();

        requestObject.world_token = world.token;
        requestObject.is_platform_search = false;
        requestObject.searched_text = this.finderInput.val().trim();

        api.getRecommendedSearches(requestObject, function(response){
            if (api.checkisValidResult(response, false, false)) {

                if (that.state === that.WRITNG) {
                    if (response.result.suggestions.length > 0) {
                        that.finderBody.html(that.recommendedSearchesTemplate(response.result));
                    } else {
                        that.finderBody.html(null);
                    }
                }
            }
        });

    }

    toggleFilter() {

        const filteredDocuments = DocumentationUtils.applyDocumentationFilters($(this), finderController.finderFilters, finderController.documents);

        finderController.drawDocumentsList(filteredDocuments);

    }

    toggleFiltersPanel() {
        this.filtersButton.hasClass("opened") ? this.hideFilters() : this.showFilters();
    }

    showFilters() {

        this.filtersButton.addClass("opened");
        this.finderFilters.slideDown("fast");

    }

    hideFilters() {

        if (this.finderFilter) {
            if (this.finderFilters.find(".filterEnabled").length > 0) {
                this.drawDocumentsList(this.documents);
            }
            this.finderFilter.removeClass("filterEnabled");
        }

        this.filtersButton.removeClass("opened");
        this.finderFilters.slideUp("fast");

    }

    drawDocumentsList(documents = []) {
        
        const that = this;
        const documentation = documentationScreenController;

        _.forEach(documents, function(document) {

            let contentMatches = [];
            let titleMatches = null;

            contentMatches = _.filter(document.search_data, function(coincidence) {

                if (coincidence.match_type === "title") {
                    titleMatches = coincidence;
                }

                return that.availableMatchContentTypes().indexOf(coincidence.match_type) >= 0;
            });

            document.name = titleMatches ? titleMatches.highlight : document.name;
            document.location = documentationScreenController.documentsRoutes[document.id];
            document.progressState = documentationScreenController.documentationProgress.getProgressState(document);
            document.contentMatches = contentMatches.slice(0, 5);

        });

        this.finderResults.html(this.searchedResultsTemplate({
            filterType: "finder",
            world: world,
            documents: documents,
            filters: {
                playFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_PLAY"],
                testFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_TEST"],
                favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
                newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"]
            }
        }));

        $(".bf-smart-list.list.finder-view .slide-actions-list-button").remove();
        $(".bf-smart-list.list .title em, .finder-match-value em").css("color", "#" + world.theme.color_1);
        $(document).undelegate("click.drawDocumentsDetails");
        $(".item-smart-list").on("click", this.drawDocumentsDetails);
    }

    drawDocumentsDetails() {
        
        $("#close-finder-button").trigger("click");
        const documentMatch = $(this).data("match");
        const documentId = $(this).data("document");
        const document = documentationScreenController.getDocument(documentId);
        const parentFolder = document.folder;
        const $finderWrapper = $("#finder-wrapper.opened");

        $finderWrapper.addClass("is-document-open");

        documentationScreenController.documentationSockets.startNodeConnection();

        if (document.type === "GAME") {
            if (document.own_game.games.length === 0) {
                finderController.documentOpen = true;
                documentationScreenController.startDocumentTypeGameOrTest(document, null, null);
                return false;
            }
        }

        if (document.type === "POLL") {
            if (document.own_poll.games.length === 0) {
                documentObj = new DocumentObj(document, []);
                api.createNewDocumentGame(document.id);
                return false;
            }
        }

        if (document.type === "PATH") {

            documentationScreenController.documentationPath.getPath(document.path_id, function(pathData) {
                document.pathData = pathData;
                documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);
            });

            return false;

        }

        finderController.documentOpen = true;
        finderController.documentMatch = documentMatch;

        documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);

        const $closeDocumentDetails = $("#documentation-header-close-btn");

        $closeDocumentDetails.one("click.closeDocumentFromFinder", function() {
            $finderWrapper.removeClass("is-document-open");
        });

    }

    availableMatchContentTypes() {
        return ["content_by_pages", "content_ocr_offsets", "content_speech_offsets", "content_ocr", "content_html"];
    }

}
